import "../../App.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import mitwankloginimg from "../../media/login_img.png";

export default function DoctorLogin() {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const loginDoctor = (pwd) => {
    if (!email || !pwd) {
      toast.error("Email and password required");
      return;
    }
    const Url = window.API_PREFIX + "admin/doctorlogin";
    fetch(Url, {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({ Email: email, Password: pwd }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data?.status === "1") {
          localStorage.setItem("DToken", data["Token"]);
          localStorage.setItem("LoginDetails", "Doctor");
          if (data["doctorId"]) localStorage.setItem("doctorId", String(data["doctorId"]));
          if (data["clinic"]) localStorage.setItem("clinicId", String(data["clinic"]));
          navigate("/doctor/dashboard");
        } else {
          toast.error(data?.message || "Login failed");
        }
      })
      .catch(() => toast.error("Login failed"));
  };

  useEffect(() => {
    if (localStorage.getItem("DToken") && localStorage.getItem("LoginDetails") === "Doctor") {
      navigate("/doctor/dashboard");
    }
  }, [navigate]);

  return (
    <div className="container">
      <div className="mitwank_login_main_division">
        <div className="mitwank_login_main_first_division">
          <div className="d-flex justify-content-center">
            <div className="mitwank_login_img_division">
              <img className="mitwank_login_img" src={mitwankloginimg} />
            </div>
          </div>
        </div>

        <div className="mitwank_login_main_second_division">
          <div className="mitwank_login_title_name">Doctor Login</div>

          <div className="mitwank_login_email_field_division form-floating mt-3">
            <TextField
              id="outlined-basic"
              label="Email / UserId"
              variant="outlined"
              className="w-100"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <FormControl sx={{ width: "100%" }} variant="outlined" className="mt-3">
            <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              value={password}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="Password"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") loginDoctor(e.target.value);
              }}
            />
          </FormControl>

          <div
            className="mitwank_login_forgot_password_division"
            onClick={() => {
              navigate("/doctorforgetpassword");
            }}
          >
            Forgot Password ?
          </div>

          <button
            className="mitwank_login_btn_login_division"
            onClick={() => loginDoctor(password)}
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
}

